// src/config/environment.ts

interface EnvironmentConfig {
  API_BASE_URL: string;
  APP_NAME: string;
  APP_VERSION: string;
  NODE_ENV: string;
}

const config: EnvironmentConfig = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  APP_NAME: process.env.REACT_APP_NAME || 'CDT Admin Portal',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  NODE_ENV: process.env.NODE_ENV || 'development',
};

export default config;

// Helper functions
export const isDevelopment = () => config.NODE_ENV === 'development';
export const isProduction = () => config.NODE_ENV === 'production';
export const isTest = () => config.NODE_ENV === 'test';

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_OTP: '/auth/verify-otp',
    REFRESH_TOKEN: '/auth/refresh-token',
    PROFILE: '/auth/profile',
  },
  USER: {
    PROFILE: '/user/profile',
    UPDATE_PROFILE: '/user/profile',
    CHANGE_PASSWORD: '/user/change-password',
  },
  UPLOAD:{
    UPLOAD_FILE: '/distributors/upload',
  },
  DISTRIBUTOR:{
    GET_DISTRIBUTOR_LIST: '/distributors',
    GET_DISTRIBUTOR_BY_ID: '/distributors/:id',
    CREATE_DISTRIBUTOR: '/distributors',
    UPDATE_DISTRIBUTOR: '/distributors/:id',
    DELETE_DISTRIBUTOR: '/distributors/:id',
    GET_DISTRIBUTOR_ORDER_LIMIT: '/distributors/orders/limit/:name',
    GET_DISTRIBUTOR_ORDER: '/distributors/orders/:name',
    LINK_SERVER: '/distributors/link-server/:id',
    SYNC_DISTRIBUTOR: '/distributors/:id/sync',
    SUBSCRIPTION_OTP: '/distributors/:id/subscription-otp',
  },
  BRIDGE: {
    PUBLIC_KEY: '/bridge/public-key',
  },
  INVOICE:{
    GET_INVOICES: '/invoices',
  },
  PAYMENT:{
    CREATE_PAYMENT: '/payments',
  },
  PROMO:{
    GET_PROMO_LIST: '/promoted-items',
    GET_PROMO_BY_ID: '/promoted-items/:id',
    CREATE_PROMO: '/promoted-items',
    UPDATE_PROMO: '/promoted-items/:id',
    DELETE_PROMO: '/promoted-items/:id',
  },
  DASHBOARD:{
    GET_DASHBOARD_DATA: '/dashboard',
    GET_RECENTLY_PROMOTED_ITEMS: '/dashboard/recently-promoted-items',
  },
  POLICIES:{
    GET_POLICIES: '/policies',
    GET_POLICY_BY_ID: '/policies/:id',
    GET_POLICY_BY_COMPANY_ID: '/policies/company/:id',
    CREATE_POLICY: '/policies',
    UPDATE_POLICY: '/policies/:id',
    DELETE_POLICY: '/policies/:id',
  },
  PROFILE:{
    GET_PROFILE: '/profile',
    UPDATE_PROFILE: '/profile',
    CHANGE_PASSWORD: '/profile/change-password',
  },
  SERVER:{
    GET_SERVER_LIST: '/servers',
    GET_SERVER_LIST_FOR_LINK: '/servers/list',
    GET_SERVER_BY_ID: '/servers/:id',
    CREATE_SERVER: '/servers',
    UPDATE_SERVER: '/servers/:id',
    DELETE_SERVER: '/servers/:id',
  },
  SERVICE_TYPE:{
    GET_SERVICE_TYPE_LIST: '/service-types',
    GET_SERVICE_TYPE_BY_ID: '/service-types/:id',
    CREATE_SERVICE_TYPE: '/service-types',
    UPDATE_SERVICE_TYPE: '/service-types/:id',
    DELETE_SERVICE_TYPE: '/service-types/:id',
  },
  NEW_VERSION: {
    GET_ALL: '/new-versions',
    CREATE: '/new-versions',
    GET_BY_ID: '/new-versions/:id',
    UPDATE: '/new-versions/:id',
    DELETE: '/new-versions/:id',
    RESEND: '/new-versions/:id/resend',
    ELIGIBLE_SERVERS: '/new-versions/eligible-servers',
  },
  APP_UPDATE: {
    GET_ALL: '/app-updates',
    CREATE: '/app-updates',
    GET_BY_ID: '/app-updates/:id',
    UPDATE: '/app-updates/:id',
    DELETE: '/app-updates/:id',
  },
  TICKETS: {
    GET_ALL: '/tickets',
    UPDATE: '/tickets/:id',
  },
  QUOTE: {
    GET_ALL: '/service-requests',
    UPDATE: '/service-requests/:id',
  },
  LEAD: {
    GET_ALL: '/contactus-requests',
    UPDATE: '/contactus-requests/:id',
  },
  MONITOR: {
    GET_STATUS: '/monitor/status',
    GET_HISTORY: '/monitor/history/:id',
    CHECK_ONE: '/monitor/check/:id',
    CHECK_ALL: '/monitor/check-all',
    RELOAD: '/monitor/reload',
    GET_SETTINGS: '/monitor/settings',
    UPDATE_SETTINGS: '/monitor/settings',
    TEST_ALERT: '/monitor/test-alert',
  },
  BLOG: {
    GET_ALL: '/blogs',
    CREATE: '/blogs',
    UPDATE: '/blogs/:id',
    DELETE: '/blogs/:id',
  },
} as const; 